import { Link } from "react-router-dom";
import FeedbackForm from "@/pages/about/components/FeedbackForm";

const STATS = [
  { value: "120+", label: "覆盖赛事联赛", icon: "ri-trophy-line" },
  { value: "5000+", label: "累计直播场次", icon: "ri-live-line" },
  { value: "80万", label: "注册篮球爱好者", icon: "ri-group-line" },
  { value: "7×24h", label: "赛程资讯更新", icon: "ri-time-line" },
];

const VALUES = [
  {
    icon: "ri-focus-3-line",
    title: "专注篮球",
    desc: "我们只做篮球直播这一件事，把赛事直播、赛程与资讯打磨到极致，让每一次观赛都顺畅舒心。",
  },
  {
    icon: "ri-flashlight-line",
    title: "实时为先",
    desc: "以最快速度同步比分、赛况与资讯，不让球迷错过任何一个关键回合与精彩瞬间。",
  },
  {
    icon: "ri-team-line",
    title: "球迷共创",
    desc: "认真倾听每一位用户的反馈，和球迷一起把平台做得更好，让热爱被看见、被连接。",
  },
];

const TEAM = [
  { name: "直播技术组", role: "负责多线路高清直播与播放器体验优化" },
  { name: "赛程数据组", role: "维护各大联赛赛程、比分与球员技术统计" },
  { name: "内容编辑部", role: "产出赛事新闻、技术分析与球员深度报道" },
];

export default function AboutPage() {
  return (
    <div className="w-full">
      <section className="relative w-full h-64 md:h-80 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20dramatic%20basketball%20arena%20with%20orange%20spotlights%20and%20deep%20navy%20seating%2C%20cinematic%20empty%20court%2C%20professional%20sports%20broadcast%20atmosphere%2C%20high%20contrast&width=1920&height=900&seq=bb-about-hero-01&orientation=landscape"
          alt="篮球直播平台团队"
          title="关于篮球直播 - 高清篮球比赛直播平台"
          className="absolute inset-0 w-full h-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-primary-950/45" />
        <div className="relative h-full w-full px-4 md:px-6 flex flex-col justify-center">
          <nav className="flex items-center gap-1.5 text-xs text-primary-200 mb-3">
            <Link to="/" className="hover:text-accent-400 cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-accent-400">关于我们</span>
          </nav>
          <h1 className="font-heading font-semibold text-3xl md:text-4xl text-background-50">
            关于篮球直播
          </h1>
          <p className="mt-3 max-w-2xl text-primary-100 text-sm md:text-base leading-relaxed">
            我们是一群热爱篮球的人，想把最纯粹的观赛体验带给每一位球迷。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-accent-600 uppercase">
              Who We Are
            </span>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950 mt-2">
              网站背景介绍
            </h2>
            <div className="mt-5 space-y-4 text-foreground-700 leading-relaxed">
              <p>
                篮球直播诞生于一群资深球迷的执念：为什么看球这件事，不能更简单、更流畅一点？
                于是我们搭建了这个平台，把高清比赛实况、详尽赛程安排与专业赛事资讯集中在一处。
              </p>
              <p>
                平台覆盖 NBA、CBA、欧洲篮球联赛与女子篮球联赛等国内外主流赛事，从赛前预告、
                实时比分到赛后集锦与数据分析，帮助球迷在最短时间内掌握最关心的赛事信息。
              </p>
              <p>
                目前本站直播画面为前端演示区域，真实视频线路正在持续接入中，正式版本将提供多线路高清直播与互动观赛体验。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/schedule"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-line" />
                查看赛程
              </Link>
              <Link
                to="/news"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-newspaper-line" />
                浏览资讯
              </Link>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=basketball%20on%20a%20polished%20hardwood%20court%20near%20the%20three%20point%20line%20with%20warm%20arena%20lighting%20and%20soft%20shadow%2C%20clean%20editorial%20sports%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=900&seq=bb-about-intro-02&orientation=landscape"
              alt="篮球特写"
              title="篮球直播平台介绍 - 高清篮球比赛直播"
              className="w-full h-72 md:h-96 object-top object-cover"
            />
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 pb-12 md:pb-16">
        <div className="rounded-lg bg-primary-950 px-6 py-10 md:px-10 md:py-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s) => (
            <div key={s.label} className="text-center lg:text-left">
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-full bg-primary-800 text-accent-400 mb-3">
                <i className={`${s.icon} text-xl`} />
              </span>
              <p className="font-heading font-semibold text-2xl md:text-3xl text-background-50">
                {s.value}
              </p>
              <p className="mt-1 text-sm text-primary-200">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 pb-12 md:pb-16">
        <div className="mb-6">
          <span className="font-label text-xs tracking-[0.3em] text-accent-600 uppercase">
            Mission
          </span>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950 mt-1">
            团队与使命
          </h2>
          <p className="mt-3 max-w-2xl text-foreground-600 leading-relaxed">
            我们的使命是让每一位篮球爱好者，都能用最简单的方式看到最好的比赛。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-8">
          {VALUES.map((v) => (
            <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-4">
                <i className={`${v.icon} text-2xl`} />
              </span>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{v.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
        <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h3 className="font-heading text-lg text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-group-line text-accent-600" />
            核心团队
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {TEAM.map((t) => (
              <div key={t.name} className="rounded-md bg-background-50 border border-background-200 p-4">
                <p className="font-medium text-foreground-900">{t.name}</p>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{t.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-8">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-accent-600 uppercase">
              Contact
            </span>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950 mt-1 mb-5">
              联系我们
            </h2>
            <div className="space-y-4">
              {[
                { icon: "ri-map-pin-line", label: "办公地址", value: "北京市朝阳区体育文化产业园 A 座 12 层" },
                { icon: "ri-mail-line", label: "邮箱", value: "feedback@basketball-live.demo" },
                { icon: "ri-phone-line", label: "合作电话", value: "400-000-2026" },
                { icon: "ri-time-line", label: "服务时间", value: "每日 09:00 - 22:00（比赛日延长至凌晨）" },
              ].map((c) => (
                <div key={c.label} className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="w-10 h-10 shrink-0 inline-flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={c.icon} />
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">{c.label}</p>
                    <p className="text-sm text-foreground-900 mt-0.5">{c.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <FeedbackForm />
        </div>
      </section>
    </div>
  );
}